export default "__VITE_ASSET__BrQ_jPKc__"